/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Enum values for calendar item subtypes: - `PG_HEALTH`: product group health - `PG_BODY`: product group body - `PG_BEAUTY`: product group beauty - `PG_HAIR`: product group hair - `PG_WELLNESS`: product group wellness 
 */
export const CalendarItemSubTypeDTO = {
    PG_HEALTH: 'PG_HEALTH',
    PG_BODY: 'PG_BODY',
    PG_BEAUTY: 'PG_BEAUTY',
    PG_HAIR: 'PG_HAIR',
    PG_WELLNESS: 'PG_WELLNESS'
} as const;
export type CalendarItemSubTypeDTO = typeof CalendarItemSubTypeDTO[keyof typeof CalendarItemSubTypeDTO];

